import type { MedicationOption } from '../../../shared/types/CardCategories/MedicationOption';
import { TRANSLATION_CLASS_NAMES } from '../../../utils/element-ids';

export const transformMedicationOptions = (
  medicationOptions: MedicationOption[] | null | undefined,
): MedicationOption[] =>
  Array.isArray(medicationOptions)
    ? ([
        {
          label: 'Select medication',
          value: '',
          className:
            TRANSLATION_CLASS_NAMES.TRANSLATION_CLASS_NAME,
        },
        ...medicationOptions.map((option: MedicationOption) => ({
          label: option.label,
          value: option.value,
        })),
      ] as MedicationOption[])
    : [];
